import SliderPrevButton from './SliderPrevButton';
export default SliderPrevButton;
